<template>
  <div class="relative min-h-screen">
    <div class="h-80 bg-bgheader w-full absolute top-0 left-0 z-0"></div>
    <div class="relative z-10 pt-8 pb-10">
      <div class="p-3">
        <h1 class="text-right text-lg font-bold mb-3 mr-2 text-white">
          لیست آدرس های مشتری
        </h1>
        <!-- لیست آدرس‌ها با radio -->
        <div v-if="addresses.length > 0" class="mt-5">
          <div
            v-for="(item, index) in addresses"
            :key="index"
            @click="getSelectedAddress(item.id, item.address)"
            class="cursor-pointer rounded-2xl border-2 p-4 transition-all duration-300 ease-in-out transform mx-3 my-2"
            :class="{
              'border-red-500 font-bold shadow-lg bg-red-50 scale-[1.02]':
                selectedAddressId === item.id,
              'border-gray-300 bg-white': selectedAddressId !== item.id,
            }"
          >
            <div class="text-sm text-gray-700 space-y-2">
              <div class="flex items-center">
                <font-awesome-icon icon="shop" class="text-bgfont text-base" />
                <span class="px-2">{{ item.storeName }}</span>
              </div>
              <div class="flex items-center">
                <font-awesome-icon
                  icon="square-phone-flip"
                  class="text-bgfont text-base"
                />
                <span class="px-2">{{ item.tel }}</span>
              </div>
              <div class="flex items-center">
                <font-awesome-icon
                  icon="location-dot"
                  class="text-bgfont text-base"
                />
                <span class="px-2">{{ item.address }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex flex-row justify-center text-center text-white mt-20"
          v-else-if="addresses.length <= 0 && !showAddAddress"
        >
          <font-awesome-icon icon="location-dot" class="fa-xl text-bgfont" />
          <h5 class="mr-1">برای این مشتری آدرسی ثبت نشده است</h5>
        </div>
        <!--دکمه افزودن آدرس جدید -->
        <div class="bottom-20 mt-6 mx-2 grid grid-cols-2 gap-x-1">
          <button
            @click="addAddress"
            class="bg-bgbutton p-2 rounded-3xl border border-yellow-500 text-cyan-900 shadow-lg"
          >
            افزودن آدرس
          </button>
          <button
            class="bg-bgbutton p-2 rounded-3xl border border-yellow-500 text-cyan-900 shadow-lg disabled:bg-slate-300 disabled:cursor-no-drop disabled:border disabled:border-slate-400"
            :disabled="!selectedAddressId"
            @click="navigateUser()"
          >
            ادامه
          </button>
        </div>
        <!--درصورتی که فروشگاه بسته است یا تمایلی به خرید محصولات تبرک ندارد -->

        <div class="flex flex-col w-full max-w-sm mx-2 mt-14">
          <h5 class="mr-1 text-center text-sm text-red-600 font-bold">
            درصورتی که فروشگاه بسته است یا تمایلی به خرید محصولات تبرک ندارد
            توضیحات خودرا وارد نمایید ودکمه ثبت بزنید
          </h5>
          <label for="description" class="font-bold pb-2">توضیحات</label>
          <textarea
            id="description"
            v-model="description"
            ref="descriptionField"
            class="p-4 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-1 focus:ring-yellow-500 focus:border-yellow-500 resize-none overflow-hidden transition-all duration-200 ease-in-out"
            style="min-height: 40px"
            placeholder="متن خود را اینجا وارد کنید..."
            @input="autoResize"
          />
        </div>
        <div class="bottom-20 mt-6 mx-2 grid grid-cols-1 gap-x-1">
          <button
            @click="addDescription"
            class="bg-bgbutton p-2 rounded-3xl border border-yellow-500 text-cyan-900 shadow-lg"
          >
            ثبت توضیحات
          </button>
        </div>
        <!--مودال افزودن ادرس جدید-->
        <transition name="fade">
          <div
            v-if="modalNewAddress"
            class="fixed inset-0 bg-gray-700 bg-opacity-50 z-50 flex justify-center items-center p-4"
            @click="modalNewAddress = false"
          >
            <div
              class="bg-white rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col gap-y-4 relative"
              @click.stop
            >
              <div class="">
                <div class="flex flex-col gap-y-4">
                  <h1
                    class="text-center text-lg font-bold mb-3 pt-9 mr-2 text-cyan-900"
                  >
                    افزودن آدرس جدید
                  </h1>
                  <form
                    action="#"
                    @submit.prevent="createAddress()"
                    class="px-2 py-4 text-cyan-900 text-sm mt-2 mx-4 overflow-scroll my-6"
                  >
                    <div class="flex gap-x-2">
                      <textarea
                        id="address"
                        v-model="this.customer.address"
                        placeholder="آدرس را وارد کنید یا از نقشه انتخاب کنید"
                        class="w-full text-xs border px-3 py-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-400 resize-none border-gray-300"
                        rows="1"
                        @input="autoResize"
                      ></textarea>

                      <!-- <button
                        @click="openMapModal"
                        type="button"
                        class="bg-yellow-400 text-black px-3 py-3 mt-1 h-[40px] rounded-lg hover:bg-yellow-300 transition flex items-center justify-center"
                      >
                        <font-awesome-icon
                          icon="location-dot"
                          class="fa-md text-bgfont"
                        />
                      </button> -->
                    </div>
                    <span
                      class="text-xs text-red-500"
                      v-if="inputAddress.error"
                      >{{ inputAddress.error }}</span
                    >
                    <input
                      class="border p-2 text-center rounded-lg text-black w-full mt-2 border-gray-300"
                      type="tel"
                      placeholder="تلفن"
                      v-model="this.customer.tel"
                    />
                    <span
                      class="text-xs text-red-500"
                      v-if="inputPhone.error"
                      >{{ inputPhone.error }}</span
                    >
                    <input
                      class="border p-2 text-center rounded-lg text-black w-full mt-2 border-gray-300"
                      type="text"
                      placeholder="نام فروشگاه"
                      v-model="this.customer.storeName"
                    />
                    <span
                      class="text-xs text-red-500"
                      v-if="inputStoreName.error"
                      >{{ inputStoreName.error }}</span
                    >
                    <VButton
                      class="w-full mt-4 text-cyan-900 disabled:bg-slate-300 disabled:text-black disabled:cursor-pointer"
                      type="submit"
                      :disabled="loading"
                    >
                      ثبت
                    </VButton>
                  </form>
                </div>
              </div>
            </div>
            <!-- <transition name="fade">
              <div
                v-if="modalLocation"
                class="fixed inset-0 bg-gray-700 bg-opacity-50 z-60 flex justify-center items-center p-4"
                @click="modalLocation = false"
              >
                <div
                  class="bg-white rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col gap-y-4 relative"
                  @click.stop
                >
                  <font-awesome-icon
                    icon="xmark"
                    class="absolute top-2 right-2 text-red-700 text-xl font-bold z-10"
                    @click="modalLocation = false"
                  />
                  <h2 class="text-center text-lg font-semibold p-4 border-b">
                    لطفا موقعیت خود را انتخاب نمایید
                  </h2>

                  <div class="flex-1 relative">
                    <NeshanMapLeaflet
                      :options="options"
                      @latitude="getLatitude"
                      @longitude="getLongitude"
                      class="w-full h-full"
                    />
                  </div>

                  <button
                    class="bg-bgbutton px-3 py-2 rounded-3xl text-cyan-900 border border-yellow-500 shadow-lg disabled:bg-slate-300 disabled:cursor-no-drop disabled:border disabled:border-slate-400 mb-5 mx-6"
                    @click="insertLocation"
                  >
                    ادامه
                  </button>
                </div>
              </div>
            </transition> -->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAddress,
  postAddress,
  getLocation,
  postManualVisit,
} from "../API/API";
//import { NeshanMapLeaflet } from "vuejs-neshan-map-leaflet";
import VButton from "../components/General/VButton";
export default {
  name: "CustomerAddress",
  data() {
    return {
      description: "",
      addressesId: null,
      addresses: [], // آدرس‌های مشتری
      selectedAddress: null, // آدرس انتخاب‌شده
      selectedAddressId: null,
      newAddress: "", // آدرس جدید
      modalLocation: false, // برای باز کردن نقشه
      modalNewAddress: false,
      showAddAddress: false,
      location: "",
      latitude: "",
      longitude: "",
      LaCustomer: "",
      LoCustomer: "",
      customerId: this.$route.params.customerId,
      options: {
        key: "web.7cc330791e06469891c900b1b6a4c6d6",
        maptype: "dreamy",
        poi: true,
        traffic: false,
        center: [36.30284183765441, 59.5958496945331],
        zoom: 13,
      },
      customer: {
        customer_Id: "",
        storeName: "",
        isDefault: "",
        latitude: 0,
        longitude: 0,
        tel: "",
        address: "",
      },
      inputPhone: {
        error: "",
      },
      inputAddress: {
        error: "",
      },
      inputStoreName: {
        error: "",
      },
    };
  },
  components: {  VButton },
  mounted() {
    this.autoResize();
  },
  created() {
    this.getAddress();
  },
  methods: {
    ValidateForm() {
      let result = true;
      this.inputPhone.error = "";
      this.inputAddress.error = "";
      this.inputAddress.error = "";

      if (!this.customer.tel) {
        this.inputPhone.error = "لطفاشماره مشتری را وارد کنید";
        result = false;
      }
      if (!this.customer.address) {
        this.inputAddress.error = "لطفا آدرس مشتری را وارد کنید";
        result = false;
      }
      if (!this.customer.storeName) {
        this.inputStoreName.error = "لطفا نام فروشگاه را وارد کنید";
        result = false;
      }
      return result;
    },
    async getAddress() {
      console.log(this.$route.params.customerId);
      this.addresses = (await getAddress(this.customerId)).data.result;
    },
    async addAddress() {
      this.modalNewAddress = true;
      this.customer.address = "";
      this.customer.tel = "";
      this.customer.storeName = "";
    },
    insertAddress() {
      this.showAddAddress = false;
    },
    autoResize() {
      const textarea = this.$refs.descriptionField;
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    },
    getLatitude(latitude) {
      this.LaCustomer = latitude;
    },
    getLongitude(longitude) {
      this.LoCustomer = longitude;
    },
    insertLocation() {
      this.modalLocation = false;
      getLocation(this.LaCustomer, this.LoCustomer)
        .then((resp) => {
          console.log(resp);
          this.customer.address = resp.data.formatted_address;
        })
        .catch(() => {});
    },
    async createAddress() {
      if (this.ValidateForm()) {
        if (this.addresses.length <= 0) this.selectedAddress = true;
        else this.selectedAddress = false;
        const body = {
          customer_Id: this.customerId,
          storeName: this.customer.storeName,
          isDefault: this.selectedAddress,
          latitude: this.latitude || 0, // اگر this.latitude خالی بود 0 بگیرد
          longitude: this.longitude || 0, // اگر this.longitude خالی بود 0 بگیرد
          City_Id: "",
          tel: this.customer.tel,
          address: this.customer.address,
        };
        console.log(body);
        postAddress(this.customerId, body)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "موفق",
              text: "آدرس مشتری ثبت شد",
              confirmButtonColor: "#fcd34d",
              confirmButtonText: "باشه",
            }).then(() => {
              this.$router.go(0);
            });
          })
          .catch(() => {
            this.$swal({
              icon: "error",
              title: "خطا",
              text: "عملیات با شکست مواجه شد",
              confirmButtonColor: "#fcd34d",
              confirmButtonText: "باشه",
            });
          });
      }
    },
    getSelectedAddress(id, address) {
      this.selectedAddressId = id;
      localStorage.setItem("selectedAddress", address);
      localStorage.setItem("selectedAddressId", id);
    },
    navigateUser() {
      this.$router.push(`/customer/${this.customerId}/anbar/1`);
    },
    openMapModal() {
      if (this.modalNewAddress) {
        this.modalLocation = true;
      }
    },
    addDescription() {
      const body = {
        addressId: this.selectedAddressId,
        description: this.description,
      };
      if (this.selectedAddressId == null) {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "لطفا آدرس را انتخاب نمایید",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
        return;
      }
      postManualVisit(body)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "موفق",
            text: "توضیحات با موفقیت ثبت شد",
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          }).then(() => {
            this.$router.push("/customer");
          });
        })
        .catch(() => {
          this.$swal({
            icon: "error",
            title: "خطا",
            text: "عملیات با شکست مواجه شد",
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        });
    },
  },
};
</script>
